import { defineAction } from '~/prix'
import residenceImageFetchAction from './residenceImageFetch.action.json' with { type: 'json' }
import { z } from 'zod'
import { residenceImageObject } from '../imageList/residenceImageList.definition'

const residenceImageFetchDefinition = defineAction({
  ...residenceImageFetchAction,

  input: z.object({
    residenceId: z.string().uuid(),
  }),
  output: z.array(residenceImageObject),
})

export default residenceImageFetchDefinition
